module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/star-empty-37944cbbe9c8c39f89290b0165ad603b.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/star-empty.svg
// module id = HV07
// module chunks = 24